import { FC, Fragment } from 'react';

import { AffinityScore } from 'modules/ai/XAI/audienceUserProfile';

import { AffinityScoreData } from './AffinityScoreData';
import { RowDivider } from '../Styles';
import { AffinityHistoryContainer } from './ScoreCard.styles';

export interface AffinityScoreHistoryProps {
  scores: Array<AffinityScore>;
}

export const AffinityScoreHistory: FC<React.PropsWithChildren<AffinityScoreHistoryProps>> = ({
  scores,
}) => {
  return (
    <AffinityHistoryContainer data-test="brand-affinity-xai-score-history">
      {scores.map(({ relativeDate, label, date }, index, source) => (
        <Fragment key={`${label}_${date}`}>
          <AffinityScoreData relativeDate={relativeDate} date={date} label={label} />
          {index + 1 !== source.length ? <RowDivider>&#8942;</RowDivider> : null}
        </Fragment>
      ))}
    </AffinityHistoryContainer>
  );
};
